module.exports = __webpack_public_path__ + "static/media/Manuel.b75dcf93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/testimonials/Manuel.png
// module id = 1471
// module chunks = 0